import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledMedicationRefillHistoryIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_13083_28852)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M8 4H7.5V4.5V6.79289L5.23223 9.06066C4.76339 9.5295 4.5 10.1654 4.5 10.8284V20C4.5 21.3807 5.61929 22.5 7 22.5H17C18.3807 22.5 19.5 21.3807 19.5 20V10.8284C19.5 10.1654 19.2366 9.5295 18.7678 9.06066L16.5 6.79289V4.5V4H16H8Z",
					fill: "white",
					stroke: "#007AAF"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 6.5,
					y: 1.5,
					width: 11,
					height: 3,
					fill: "#4BBFDA",
					stroke: "#007AAF",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 4.5,
					y: 10.5,
					width: 15,
					height: 9,
					stroke: "#007AAF",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.1 12.75V12.25C10.8238 12.25 10.6 12.4739 10.6 12.75H11.1ZM12.9 12.75H13.4C13.4 12.4739 13.1761 12.25 12.9 12.25V12.75ZM11.1 14.1V14.6C11.3761 14.6 11.6 14.3761 11.6 14.1H11.1ZM9.75 14.1V13.6C9.47386 13.6 9.25 13.8239 9.25 14.1H9.75ZM9.75 15.9H9.25C9.25 16.1761 9.47386 16.4 9.75 16.4V15.9ZM11.1 15.9H11.6C11.6 15.6239 11.3761 15.4 11.1 15.4V15.9ZM11.1 17.25H10.6C10.6 17.5261 10.8238 17.75 11.1 17.75V17.25ZM12.9 17.25V17.75C13.1761 17.75 13.4 17.5261 13.4 17.25H12.9ZM12.9 15.9V15.4C12.6238 15.4 12.4 15.6239 12.4 15.9H12.9ZM14.25 15.9V16.4C14.5261 16.4 14.75 16.1761 14.75 15.9H14.25ZM14.25 14.1H14.75C14.75 13.8239 14.5261 13.6 14.25 13.6V14.1ZM12.9 14.1H12.4C12.4 14.3761 12.6238 14.6 12.9 14.6V14.1ZM11.1 13.25H12.9V12.25H11.1V13.25ZM11.6 14.1V12.75H10.6V14.1H11.6ZM9.75 14.6H11.1V13.6H9.75V14.6ZM10.25 15.9V14.1H9.25V15.9H10.25ZM11.1 15.4H9.75V16.4H11.1V15.4ZM11.6 17.25V15.9H10.6V17.25H11.6ZM12.9 16.75H11.1V17.75H12.9V16.75ZM12.4 15.9V17.25H13.4V15.9H12.4ZM14.25 15.4H12.9V16.4H14.25V15.4ZM13.75 14.1V15.9H14.75V14.1H13.75ZM12.9 14.6H14.25V13.6H12.9V14.6ZM12.4 12.75V14.1H13.4V12.75H12.4Z",
					fill: "#007AAF"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 19,
					cy: 19,
					r: 4.5,
					fill: "white",
					stroke: "#007AAF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19 16.5V19L20.5 19.5",
					stroke: "#007AAF",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_13083_28852",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgFilledMedicationRefillHistoryIcon);
const Memo = memo(ForwardRef);
export default Memo;
